module.exports = __webpack_public_path__ + "media/stop-13.7fae7861.mp3";